import { WalletBalances } from './wallet.model';
import { RiskGroupShortCodeEnum } from '../enums/risk-group-short-code.enum';

export interface MerchantLogo {
  fileName: string;
  contentType: string;
  fileData: string;
  id: string;
}

export interface Profile {
  id: string;
  profileName: string;
  defaultMerchantFeeProfileId: string;
}

export interface RiskProfile {
  id: string;
  profileName: string;
}

export interface RiskProfileDetails extends RiskProfile {
  enabled: boolean;
}

export interface RiskProfileDropdownItem extends RiskProfile {
  balance?: RiskProfileCurrencyBalance[] | null;
}

export interface RiskProfileCurrencyBalance {
  currencyId: string;
  currencySymbol: string;
  availableAmountInUsdt: number;
}

export interface FeeProfile {
  id: string;
  profileName: string;
}

export interface MerchantRiskGroup {
  id: string;
  shortCode: RiskGroupShortCodeEnum;
  label: string;
  fundsClientWithdrawals?: boolean;
}

export interface Merchant {
  id: string;
  name: string;
  amount: number;
  logoText: string;
  logoClass: string;
  pendingActions: number;
  code: string;
  isActive: boolean;
  isMultiRiskPaymentsEnabled: boolean;
  isSweepingEnabled: boolean;
  isAssetFundingMerchant?: boolean;
  callbackUrl: string;
  supervisorEmail: string;
  date: string; // ISO date string
  logo?: MerchantLogo;
  profile: Profile;
  feeProfile: FeeProfile;
  riskProfile?: RiskProfileDropdownItem | null;
  riskGroups?: MerchantRiskGroup[];
  walletBalances: WalletBalances;
}

export interface ViewMerchant {
  id: string;
  name: string;
  amount: number;
  logoText: string;
  logoClass: string;
  pendingActions: number;
  isActive: boolean;
  isSweepingEnabled: boolean;
  logo?: MerchantLogo;
  baseCurrency: string;
  baseCurrencyDisplayPrecision: number;
  totalBalanceInBaseCurrency: number;
}

export enum MerchantEntityType {
  Client = 1,
  Service = 2,
}

export interface MerchantEntity {
  id: string;
  name: string;
  type: MerchantEntityType;
}

export interface CreateMerchantEntityRequest {
  type: MerchantEntityType;
  name: string;
}

// Mirrors the backend System.DayOfWeek numbering.
export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export interface DailyAllowanceRiskLevel {
  riskLevel: string;
  allowances: Record<DayOfWeek, number>;
}

export interface MerchantDailyAllowance {
  remainingTransactions: Record<DayOfWeek, number>;
  riskLevels: DailyAllowanceRiskLevel[];
}

export interface MerchantDelegationDto {
  riskLevels: DailyAllowanceRiskLevel[];
}
